import { render, staticRenderFns } from "./ResetPwdShopWindow.vue?vue&type=template&id=1f885edd&scoped=true&"
import script from "./ResetPwdShopWindow.vue?vue&type=script&lang=js&"
export * from "./ResetPwdShopWindow.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwdShopWindow.vue?vue&type=style&index=0&id=1f885edd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f885edd",
  null
  
)

export default component.exports